import React from 'react';
import $ from 'jquery';
import { ts } from 'src/utils/translate';
import { IncludeLayer } from './IncludeLayer';
import { getSVGViewBox } from 'src/utils/documentationUtils';

export const WiringMap = (props: {
  enabled: boolean;
  floorWiringSvgObject: any;
  tableRooms: any[];
}) => {
  const { enabled, floorWiringSvgObject, tableRooms } = props;

  const [includeLayer, setIncludeLayer] = React.useState(true);
  const [isUnassigned, setIsUnassigned] = React.useState(false);

  const wiringRef = React.useRef<any>(undefined);

  React.useEffect(() => {
    // only the Unassigned and Outdoor entries are present, i.e. there are no real rooms.
    if (tableRooms.length === 2) {
      setIsUnassigned(true);
    }
  }, [tableRooms]);

  React.useEffect(() => {
    if (
      wiringRef &&
      includeLayer &&
      enabled &&
      floorWiringSvgObject.plannerSVG &&
      floorWiringSvgObject.plannerSVG.length
    ) {
      const $wiringElem = $(wiringRef.current);
      const $svg = $wiringElem.find(".quote-floorSVG");
      if ($svg.length && floorWiringSvgObject.floorId) {
        getSVGViewBox($svg, floorWiringSvgObject.floorId).then((vb) => {
          $svg.attr("viewBox", vb);
        });
      }
    }
  }, [includeLayer, enabled, floorWiringSvgObject.plannerSVG, wiringRef]);

  return (
    <div
      style={enabled ? { animation: "fadein 0.5s" } : { display: "none" }}
      className={`map-comp-root${includeLayer ? "" : " remove-on-export"}`}
      data-wiringfloorid={floorWiringSvgObject.floorId}
    >
      <div
        style={{
          display: "flex",
          alignItems: "baseline",
          justifyContent: "space-between",
        }}
      >
        <h3 className="floorcont-pre ">
          {ts("q_wiring", "Wiring")}
          {floorWiringSvgObject.wiringType &&
            ` (${floorWiringSvgObject.wiringType})`}
        </h3>
        <IncludeLayer
          floorWiringSvgObject={floorWiringSvgObject}
          includeLayer={includeLayer}
          setIncludeLayer={setIncludeLayer}
        />
      </div>

      {isUnassigned && (
        <div
          className="alert alert-info"
          style={{ display: includeLayer ? "" : "none" }}
        >
          <strong>{ts("attention", "Attention")} </strong>
          {ts(
            "unassigned_msg",
            "Until the rooms and walls are properly delineated, the functionality cannot be used, and the cable calculation will also be inaccurate."
          )}
        </div>
      )}

      <div
        style={{
          position: "relative",
          textAlign: "center",
          display: includeLayer ? "" : "none",
        }}
        className={`map-center-align ${
          isUnassigned ? "disable-documentation-style" : ""
        }`}
      >
        {floorWiringSvgObject.plannerSVG &&
        floorWiringSvgObject.plannerSVG.length > 0 ? (
          <React.Fragment>
            <div
              ref={wiringRef}
              dangerouslySetInnerHTML={{
                __html: floorWiringSvgObject.plannerSVG[0].outerHTML,
              }}
            ></div>
          </React.Fragment>
        ) : null}
      </div>
    </div>
  );
};